import { crearTabla, mostrarToast } from '@plataforma/ui';
import { formatearFechaHora } from '@plataforma/utils';

import { listarPublicaciones, republicarTienda } from '../api/publicaciones.js';
import { exigirSuperAdmin } from '../guardas.js';

import { montarShell } from './shell.js';

const TONO_ESTADO = { en_proceso: 'info', exitosa: 'exito', fallida: 'peligro' };
const ETIQUETA_ESTADO = { en_proceso: 'En proceso', exitosa: 'Exitosa', fallida: 'Fallida' };

export async function vistaPublicaciones(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/publicaciones');
  contenido.innerHTML =
    '<h1 style="margin-bottom: 16px;">Publicaciones</h1><div id="pf-publicaciones-tabla"></div>';

  await cargarTabla(contenido);
}

async function cargarTabla(contenido) {
  const destino = contenido.querySelector('#pf-publicaciones-tabla');
  destino.innerHTML = `<p class="pf-texto-suave">Cargando...</p>`;

  const { data, error } = await listarPublicaciones();

  if (error) {
    destino.innerHTML = `<p class="pf-campo__error">No se pudo cargar el historial de publicaciones.</p>`;
    return;
  }

  const tabla = crearTabla({
    filaVacia: 'Todavia no hay publicaciones registradas.',
    columnas: [
      { titulo: 'Empresa', render: (fila) => fila.empresa?.nombre ?? '-' },
      {
        titulo: 'Estado',
        render: (fila) => {
          const badge = document.createElement('pf-badge-estado');
          badge.setAttribute('tono', TONO_ESTADO[fila.estado] ?? 'neutral');
          badge.textContent = ETIQUETA_ESTADO[fila.estado] ?? fila.estado;
          return badge;
        },
      },
      { titulo: 'Iniciada', render: (fila) => formatearFechaHora(fila.iniciado_en) },
      {
        titulo: 'Finalizada',
        render: (fila) => (fila.finalizado_en ? formatearFechaHora(fila.finalizado_en) : '-'),
      },
      {
        titulo: 'Detalle',
        render: (fila) => (fila.estado === 'fallida' ? (fila.detalle_error ?? '-') : '-'),
      },
      {
        // Fase 9: metricas basicas de la publicacion (ver ADR-0010 y
        // migracion 20260101000014_publicacion_metricas.sql) — permiten
        // notar a simple vista si una publicacion empieza a degradarse
        // (mas lenta o con muchos mas archivos de lo usual) sin tener que
        // ir a los logs de la Edge Function.
        titulo: 'Rendimiento',
        render: (fila) => {
          if (fila.duracion_ms === null || fila.duracion_ms === undefined) return '-';
          const segundos = (fila.duracion_ms / 1000).toFixed(1);
          const archivos =
            fila.archivos_generados !== null && fila.archivos_generados !== undefined
              ? ` · ${fila.archivos_generados} archivos`
              : '';
          return `${segundos}s${archivos}`;
        },
      },
      {
        titulo: 'Acciones',
        render: (fila) => {
          const boton = document.createElement('button');
          boton.type = 'button';
          boton.className = 'pf-boton pf-boton--secundario pf-boton--chico';
          boton.textContent = 'Republicar';
          boton.disabled = fila.estado === 'en_proceso';
          boton.addEventListener('click', async () => {
            boton.disabled = true;
            boton.textContent = 'Publicando...';

            const { error: errorPublicacion } = await republicarTienda(fila.empresa_id);
            if (errorPublicacion) {
              mostrarToast(errorPublicacion.message, { tono: 'peligro' });
            } else {
              mostrarToast('Tienda republicada correctamente.', { tono: 'exito' });
            }

            await cargarTabla(contenido);
          });
          return boton;
        },
      },
    ],
    filas: data ?? [],
  });

  destino.innerHTML = '';
  destino.appendChild(tabla);
}
